// import Vue from 'vue'
//import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
import {getApiProps} from "@/lib/lib";
//const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}

export default {
    state: {
        locatorUnitsIds: [],
        locatorTokenParams: {},
    },
    actions: {
        fetchLocatorAppUser({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchLocatorAppUser', args, time: Date.now() / 1000})
                this.$api.locator.getAppUser(args)
                    .then((response) => {
                        let data = response.data || {}
                        commit('updateAppUser', data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLocatorAppUser', args, inprogress: false})
                    });
            })
        },
        fetchLocatorUnits({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchLocatorUnits', args, time: Date.now() / 1000})
                const params = getApiProps('locator_units', args)
                delete params.token;
                this.$api.locator.getUnits(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateUnits', data)
                        commit('setLocatorUnitsIds', data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLocatorUnits', args, inprogress: false})
                    });
            })
        },
        fetchLocatorUnitsLmsgs({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchLocatorUnitsLmsgs', args, time: Date.now() / 1000})
                const params = getApiProps('locator_unitslmsgs', args)
                delete params.token;
                this.$api.locator.getUnitsLmsgs(args, params)
                    .then((response) => {
                        let data = response.data || []
                        commit('updateUnitsLmsgs', data)
                        // this.setUnitsShowOnMap({showOnMap: true, })
                        // this.setMapCenter(this.lmsg?.latlng)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLocatorUnitsLmsgs', args, inprogress: false})
                    });
            })
        },
        fetchLocatorUnitWeather({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token || !args.unitId) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchLocatorUnitWeather', args, time: Date.now() / 1000})
                const params = getApiProps('locator_weathers', args)
                delete params.token;delete params.unitId;
                this.$api.locator.getUnitWeather(args.unitId, args, params)
                    .then((response) => {
                        let data = response.data
                        commit('updateWeathers', data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLocatorUnitWeather', args, inprogress: false})
                    });
            })
        },
        checkLocatorToken({commit, dispatch}, args) {
            return new Promise((resolve, reject) => {
                if (!args.token) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'checkLocatorToken', args, time: Date.now() / 1000})
                this.$api.locator.checkToken(args)
                    .then((response) => {
                        commit('setLocatorTokenParams', response.data)
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'checkLocatorToken', args, inprogress: false})
                    });
            })
        },
        fetchLocatorLinks/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchLocatorLinks', args, time: Date.now() / 1000})

                const params = getApiProps('locator_units', args)
                this.$api.locator.getAll({...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLocatorLinks', args, inprogress: false})
                    });
            })
        },
        saveLocatorLink({dispatch}, link) {
            let fn = (link.id) ? 'updateLocatorLink' : 'createLocatorLink'
            return dispatch(fn, link);
        },
        createLocatorLink({commit, dispatch}, link) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('locator_units')
                this.$api.locator.create(link, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateLocatorLink', response.data)
                            dispatch('fetchLocatorLinkChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateLocatorLink({dispatch,commit}, link) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('locator_units')
                this.$api.locator.update(link.id, link, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateLocatorLink', response.data)
                            dispatch('fetchLocatorLinkChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteLocatorLink({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('locator_units')
                this.$api.locator.delete(id, params)//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteLocatorLink', id)
                            else commit('updateLocatorLink', response.data)
                            dispatch('fetchLocatorLinkChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        fetchLocatorLinkChanged() {
            //
        }
    },
    mutations: {
        setLocatorUnitsIds(state, units) {
            units = units.map(u => +u.id)
            state.locatorUnitsIds = units
        },
        setLocatorTokenParams(state, params) {
            state.locatorTokenParams = {...state.locatorTokenParams, ...params}
            if (params.error) state.locatorUnitsIds = []
        },
        updateLocatorLink(/*state, link*/) {
            //
        },
    },
    getters: {
        getLocatorUnitsIds(state) {
            return state.locatorUnitsIds
        },
        getLocatorTokenParams(state) {
            return state.locatorTokenParams
        }
    }
}
